/**
 * Created by user on 12/13/2016.
 */
var incentive = { incentive: '=' };
var DetailSamplingActivateController = (function () {
    function DetailSamplingActivateController(topic, env, socket, $scope, Dialog, notify, $window) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.$window = $window;
        this.updateArray = ['sampling', 'complcl_sampling_' + this.incentive];
        this.sampReason = '';
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        this.documentationStatusValues = [];
        this.ssaDocumentationStatus = '';
        this.engagementDocumentationStatus = '';
        this.events = { active: false, complete: false, overridden: false, updating: false };
        this.sampReasonOther = '';
        this.checkListArr = {};
        //this.isCLLoaded = false;
        this.reasonList = [
            'Opportunity requires Standard Exception',
            'Sampling requested by SME',
            'BP on high-risk potential list',
            'Influenced opportunity',
            'BPs 1st additional selection after failure',
            'BPs 2nd additional selection after failure',
            'Government sale',
            'Base sampling',
            'Other'
        ];
        this.documentationStatusValues = ['Not Provided', 'Need More Evidence', 'Submitted', 'Reviewed'];
        this.incentiveList = [
            'SSA',
            'Solution',
        ];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, change event props accordingly
            _this.checkEvents();
        });
        // Listener for the an Activation or Deactivation is fired and returned from the server
        this.socket.forward('addsampling.done', this.$scope);
        this.$scope.$on('socket:addsampling.done', function (event, data) {
            _this.events.updating = false; // Done updating
            _this.checkEvents();
            _this.incentiveStatus = data.data[_this.incentive] || data.data;
            // If an error...spew it
            if (data.error) {
                _this.notify.error(data.error);
            }
            _this.$window.location.reload();
        });
    }
    /**
     * Function to determine various property values based on what's going on
     */
    DetailSamplingActivateController.prototype.checkEvents = function () {
        if (this.topic.isSamplingStarted(this.incentive)) {
            this.events.active = true;
        }
        else {
            this.events.active = false;
        }
        if (this.topic.isSamplingComplete(this.incentive)) {
            this.events.complete = true;
            if (this.incentiveStatus.samplingStatus === 'Manual override') {
                this.events.overridden = true;
                this.events.active = false;
            }
        }
        else {
            this.events.complete = false;
        }
    };
    DetailSamplingActivateController.prototype.$onInit = function () {
        this.incentiveStatus = this.topic.topic.sampling[this.incentive] || this.topic.topic.sampling;
        this.checkEvents();
        this.ssaDocumentationStatus = _.get(this, 'topic.topic.sampling.SSA.documentationStatus') || 'Not Provided';
        this.engagementDocumentationStatus = _.get(this, 'topic.topic.sampling.Solution.documentationStatus') || 'Not Provided';
    };
    DetailSamplingActivateController.prototype.sampButton = function (what, status) {
        var _this = this;
        var v4OrLater = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_4;
        var items = {
            action: what, reasons: this.reasonList,
            incentives: this.incentiveList,
            incentiveStatus: this.incentiveStatus,
            incentive: this.incentive,
            v4OrLater: v4OrLater,
            ssaDocumentationStatus: this.ssaDocumentationStatus,
            engagementDocumentationStatus: this.engagementDocumentationStatus,
            documentationStatusValues: this.documentationStatusValues,
            uiVersion: this.topic.topic.version,
            oppVersions: {
                five: this.OPP_VERSION_5
            }
        };
        this.Dialog.updateValidForm(undefined, items, 'sampling-dialog.html').then(function (dResult) {
            if (dResult.confirm) {
                // Create a package according to Activate or Deactivate
                var sampPackage = {};
                sampPackage.status = status; // new Sampling status
                sampPackage.action = what; // Activiate or Deactivate
                sampPackage.incentiveStatus = _this.incentive; // Activiate or Deactivate
                if (what === 'Activate') {
                    var reason = dResult.sampReason;
                    var incentiveReason = dResult.incentiveComment;
                    var incentiveType = angular.isUndefined(_this.incentive) ? _this.incentiveList.filter(function (el) { return dResult.incentiveType[el] === true; }) : [_this.incentive];
                    if (dResult.sampReason === 'Other') {
                        reason += ' - ' + dResult.sampReasonOther;
                    }
                    sampPackage.reason = reason;
                    sampPackage.incentiveType = incentiveType;
                    sampPackage.incentiveReason = incentiveReason;
                    sampPackage.ssaDocumentationStatus = dResult.ssaDocumentationStatus;
                    sampPackage.engagementDocumentationStatus = dResult.engagementDocumentationStatus;
                }
                else {
                    sampPackage.reason = dResult.comment;
                }
                // Creat object to send to server
                var data = {
                    opp: _this.topic.getId(_this.topic.topic._id),
                    iot: _this.topic.topic.gpp[0].iot || _this.topic.topic.iot,
                    program: _this.topic.topic.program,
                    sampPack: sampPackage
                };
                // Set flag to indicating server call...block buttons and show spinner etc
                _this.events.updating = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateSampling',
                        script: '/detail/sampling/sampling',
                        data: data,
                        user: _this.env.user,
                        bID: _this.topic.topicBrowserID //Need this to be able to utilise the update.partial socket
                    }
                });
            }
        });
    };
    DetailSamplingActivateController.$inject = ['topic', 'env', 'socket', '$scope', 'Dialog', 'notify', '$window'];
    return DetailSamplingActivateController;
}());
var DetailSamplingActivateComponent = (function () {
    function DetailSamplingActivateComponent() {
        this.templateUrl = 'detail-sampling-activate.html';
        this.controllerAs = 'vm';
        this.bindings = incentive;
        this.controller = DetailSamplingActivateController;
    }
    return DetailSamplingActivateComponent;
}());
angular
    .module('application')
    .component('detailSamplingActivateComponent', new DetailSamplingActivateComponent());

//# sourceMappingURL=detail.sampling.activate.component.js.map
